import {axiosInstance} from './axiosConfig';
import {handleRequestWithAuth} from './refreshService';
import {operatorHeaders, requireOperatorToken} from './pos/operatorGrant';

type Format = 'carta' | 'rollo';
async function fetchVoucher(id:number,sessionId:number,token:string,format:Format,output:'pdf'|'html') {
  try {
    return await handleRequestWithAuth(async()=>(await axiosInstance.get(`citas/${id}/voucher-temporizador/`,{
      params:{sesion_pos:sessionId,formato:format,salida:output},
      ...operatorHeaders(requireOperatorToken(token)),responseType:output==='pdf'?'blob':'text',
    })).data);
  } catch(e:any) {
    if(e.response?.data instanceof Blob){try{const data=JSON.parse(await e.response.data.text());throw new Error(Object.values(data).flat().join(' '));}catch(parsed:any){if(!(parsed instanceof SyntaxError))throw parsed;}}
    throw e;
  }
}
export async function downloadTimerVoucher(id:number,sessionId:number,token:string,format:Format) {
  const blob=await fetchVoucher(id,sessionId,token,format,'pdf');
  const url=URL.createObjectURL(blob),link=document.createElement('a');
  link.href=url;link.download=`voucher-temporizador-${id}-${format}.pdf`;link.click();
  window.setTimeout(()=>URL.revokeObjectURL(url),1000);
}
export async function printTimerVoucher(id:number,sessionId:number,token:string,format:Format) {
  const popup=window.open('','_blank');
  if(!popup)throw new Error('Permite abrir ventanas para imprimir el voucher.');
  try {
    const html=await fetchVoucher(id,sessionId,token,format,'html');
    popup.document.open();popup.document.write(html);popup.document.close();popup.focus();popup.print();
  }catch(e){popup.close();throw e;}
}
